<main class="c-main">
  <div class="container-fluid">
    <mat-card class="mat-elevation-z8">
      <div class="wow-form-header">
        <div class="wow-form-header__icon"><mat-icon>receipt_long</mat-icon></div>
        <mat-card-title>Geração de Conta a Receber em Lote</mat-card-title>
      </div>

      <div class="row align-items-end">
        <div class="col-12 col-md-3">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Projeto (Segmento)</mat-label>
            <mat-select [(value)]="segmentoId">
              <mat-option [value]="null">Todos</mat-option>
              <mat-option *ngFor="let s of segmentos" [value]="s.id">{{ s.nome }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-3">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Competência</mat-label>
            <input matInput [value]="competenciaLabel" readonly (click)="pickerCompetencia.open()">
            <input matInput hidden [matDatepicker]="pickerCompetencia" [(ngModel)]="dataCompetencia"
              (dateChange)="onCompetenciaChange()">
            <mat-datepicker-toggle matSuffix [for]="pickerCompetencia"></mat-datepicker-toggle>
            <mat-datepicker #pickerCompetencia startView="multi-year"
              (monthSelected)="onMesSelecionado($event, pickerCompetencia)"></mat-datepicker>
            <mat-hint>Selecione o mês/ano — o vencimento usa o dia do plano de cada segmento.</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Forma de cobrança</mat-label>
            <mat-select [(value)]="formaCobranca">
              <mat-option value="MANUAL">Manual (sem emissão)</mat-option>
              <mat-option value="BOLETO">Boleto</mat-option>
              <mat-option value="PIX">PIX</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2" *ngIf="formaCobranca !== 'MANUAL'">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Conta corrente</mat-label>
            <mat-select [(value)]="contaCorrenteId">
              <mat-option *ngFor="let c of contasCorrentes" [value]="c.id">{{ labelContaCorrente(c) }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-2 as-buscar-col">
          <button mat-stroked-button class="as-btn-buscar" (click)="buscar()" [disabled]="carregando">
            <mat-icon>search</mat-icon> Buscar
          </button>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Descrição da cobrança</mat-label>
            <textarea matInput [(ngModel)]="descricao" maxlength="200" rows="2"></textarea>
            <mat-hint>Tags: {{ '{plano}' }}, {{ '{periodo}' }}, {{ '{competencia}' }}, {{ '{cliente}' }}</mat-hint>
          </mat-form-field>
        </div>
        <div class="col-12 col-md-6">
          <mat-form-field class="full-width" appearance="fill">
            <mat-label>Observação (opcional)</mat-label>
            <textarea matInput [(ngModel)]="observacao" rows="2"></textarea>
            <mat-hint>Aceita as mesmas tags. Com mais de 1 empresa, concatena ao detalhamento gerado.</mat-hint>
          </mat-form-field>
        </div>
      </div>

      <p *ngIf="carregando">Carregando...</p>

      <ng-container *ngIf="consultou && !carregando">
        <div *ngIf="previa.length === 0" class="as-vazio">
          Nenhum cliente pendente para gerar nesta competência (os que já possuem conta a receber não são exibidos).
        </div>

        <div *ngIf="previa.length > 0" class="as-tabela">
          <table class="table table-hover">
            <thead>
              <tr>
                <th style="width: 40px;">
                  <mat-checkbox [checked]="todosMarcados()" (change)="alternarTodos($event.checked)"></mat-checkbox>
                </th>
                <th>Cliente pagador</th>
                <th>Documento</th>
                <th class="text-center">Vinculados</th>
                <th class="text-end">Valor total</th>
                <th style="width: 60px;"></th>
              </tr>
            </thead>
            <tbody>
              <ng-container *ngFor="let p of previa">
                <tr>
                  <td>
                    <mat-checkbox [checked]="selecionados.has(p.clienteId)"
                      (change)="alternarSelecao(p.clienteId)"></mat-checkbox>
                  </td>
                  <td>{{ p.nome }}</td>
                  <td>{{ p.documento }}</td>
                  <td class="text-center">{{ p.vinculados.length }}</td>
                  <td class="text-end">{{ p.valorTotal | currency:'BRL' }}</td>
                  <td>
                    <button mat-icon-button (click)="alternarDetalhe(p.clienteId)"
                      *ngIf="p.vinculados.length > 0">
                      <mat-icon>{{ expandido.has(p.clienteId) ? 'expand_less' : 'expand_more' }}</mat-icon>
                    </button>
                  </td>
                </tr>
                <tr *ngIf="expandido.has(p.clienteId)" class="as-detalhe">
                  <td colspan="6">
                    <div class="as-detalhe__item">
                      <span>{{ p.nome }} (próprio)</span>
                      <span>{{ p.valorProprio | currency:'BRL' }}</span>
                    </div>
                    <div class="as-detalhe__item" *ngFor="let v of p.vinculados">
                      <span>{{ v.nome }} <small>{{ v.plano }}</small></span>
                      <span>{{ v.valor | currency:'BRL' }}</span>
                    </div>
                  </td>
                </tr>
              </ng-container>
            </tbody>
          </table>

          <div class="as-rodape">
            <div class="as-rodape__resumo">
              Selecionados: <strong>{{ selecionados.size }}</strong> &nbsp;|&nbsp;
              Total: <strong>{{ totalSelecionado | currency:'BRL' }}</strong>
            </div>
            <button mat-raised-button color="primary" (click)="gerar()" [disabled]="gerando">
              <mat-icon>receipt_long</mat-icon> Gerar cobranças
            </button>
          </div>
        </div>
      </ng-container>
    </mat-card>
  </div>
</main>
